<template>
  <basic-container>
    <avue-crud
            :option="option"
            :data="data"
            :page.sync="page"
            :search.sync="search"
            ref="crud"
            @row-del="rowDel"
            v-model="form"
            :permission="permissionList"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            @search-change="searchChange"
            @search-reset="searchReset"
            @refresh-change="refreshChange"
            @selection-change="selectionChange"
            @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                v-if="permission.sys_userunion_delete"
                @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'

export default {
  mixins: [mixin],
  data () {
    return {
      module: 'sys/userunion',
      form: {},
      search: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [{
              required: true,
              message: '请输入主键'
            }]
          },
          {
            label: 'sys_user.id',
            prop: 'userId',
            rules: [{
              required: true,
              message: '请输入sys_user.id'
            }]
          },
          {
            label: 'appid',
            prop: 'appid',
            rules: [{
              required: true,
              message: '请输入appid'
            }]
          },
          {
            label: 'openid',
            prop: 'openid',
            rules: [{
              required: true,
              message: '请输入openid'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      return {
        addBtn: this.permission.sys_userunion_add,
        viewBtn: this.permission.sys_userunion_view,
        delBtn: this.permission.sys_userunion_delete,
        editBtn: this.permission.sys_userunion_edit
      }
    }
  },
  methods: {
  }
}
</script>
